import { sessionState } from "@/state"

export const appendExperienceType = function(path) {
    if (sessionState.flowType) {
        path = appendSubPath(path, sessionState.flowType)
    }

    if (sessionState.experienceType) {
        return appendSubPath(path, sessionState.experienceType)
    } else {
        return path
    }
}

export const appendWebSessionId = function(url) {
    if (!url || !url.length) return url

    const sid = sessionState.session?.webSessionId
    if (!sid) return url

    if (url.indexOf("?") < 0) {
        url += "?"
    } else if (url[url.length - 1] !== "?") {
        url += "&"
    }

    url += "sid=" + encodeURIComponent(sid)

    return url
}


function appendSubPath(path, child) {
    if (!path) return path
    if (!child) return path
    if (child.startsWith("/")) child = child.substring(1) || ""
    if (!child) return path
    if (path.endsWith("/")) path = path.substring(0, path.length - 1) || ""
    return path + "/" + child
}
